import { customTextBlock, heading,
  paragraph,
  button } from "../../../text/nodes"
import { SponsorCTALeftSmallImage as SponsorCTALeftSmallImageEditor } from "./sponsor-cta-left-small-image"
import { SponsorCTALeftSmallImageSettings } from "./sponsor-cta-left-small-image-settings"
import SponsorCTALeftSmallImagePreview from "./sponsor-cta-left-small-image-preview.png"
import { getFont } from "../../../shared/fonts"

export const SponsorCTALeftSmallImage = {
  name: "SponsorCTALeftSmallImage",
  label: "call to action on left, image on right",
  EditorComponent: SponsorCTALeftSmallImageEditor,
  SettingsComponent: SponsorCTALeftSmallImageSettings,
  image: SponsorCTALeftSmallImagePreview,
  defaultProperties: {
    backgroundColor: "#FBFCFD",
    headingColor: "#000000",
    headingFontFamily: getFont("Verdana"),
    headingFontWeight: 700,
    textColor: "#4d4d4d",
    textFontFamily: getFont("Verdana"),
    textFontWeight: 400,
    sponsorLabelColor: "#858585",
    sponsorLabelFontFamily: getFont("Verdana"),
    sponsorLabelFontWeight: 700,
    image: "",
    alt: "",
    horizontalPadding: 26,
    verticalPadding: 26,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    imageBorderRadius: 0,
    columnRatio: 70,
    borderColor: "#000000",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0
  },
  defaultChildren: [
    customTextBlock([
      paragraph("SPONSOR", {
        alignment: "left"
      }),
      heading("three", "Sponsor title")
    ]),
    customTextBlock([
      paragraph("Lorem ipsum dolor sit amet, conscet etur adipiscing elit."),
      button("Learn more", {
        alignment: "left",
        size: "medium"
      })
    ])
  ]
}
